// removed by extract-text-webpack-plugin
module.exports = {"root":"root_KFFrL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/style.css
// module id = 186
// module chunks = 0